import { render, staticRenderFns } from "./PromotionQuery.vue?vue&type=template&id=587b426e&"
import script from "./PromotionQuery.vue?vue&type=script&lang=js&"
export * from "./PromotionQuery.vue?vue&type=script&lang=js&"
import style0 from "./PromotionQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionQuery.vue"
export default component.exports